import { render } from "./PrintView.vue?vue&type=template&id=c06cb2fc"
import script from "./PrintView.vue?vue&type=script&lang=js"
export * from "./PrintView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__